import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Scrollbars } from 'react-custom-scrollbars'
import BlurText from '../blurText'
import useStore from '../../store'
import './Bio.css'

const Bio = ({ bios = [], to = false, className, playOnClick }) => {
  const playByName = useStore((state) => state.playByName)
  const history = useHistory()

  const onClick = useCallback(() => {
    if (playOnClick) playByName(playOnClick, 'click')
    if (!to) return

    history.push(to)
  }, [to, history, playOnClick, playByName])

  return (
    <div className="g-bio">
      <Scrollbars>
        <div className="g-bio-inner">
          <div onClick={onClick}>
            {bios.map((text, i) => (
              <BlurText active={!to} key={i}>{text}</BlurText>
            ))}
          </div>
        </div>
      </Scrollbars>
    </div>
  )
}

export default Bio
